import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconService } from '@isophi/core-ui';

import { RouterLinkFactory } from '../../../../core/router/router-link.factory';

@Component({
  selector: 'app-holidays-dates-batch-actions',
  templateUrl: './holidays-dates-batch-actions.component.html',
  styleUrls: ['./holidays-dates-batch-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HolidaysDatesBatchActionsComponent {
  constructor(public iconService: IconService, public links: RouterLinkFactory) {}
}
